/* istanbul ignore file */

const checkIE11 = () => {
  if (typeof document !== 'undefined' || typeof window !== 'undefined') {
    return !!window.MSInputMethodContext && !!(document as any).documentMode;
  }

  return false;
};

const isIE11 = checkIE11();

export default isIE11;
